import { BiDownload } from "react-icons/bi";
import { Modal, Button, Typography } from "components";
import { downloadTransactionDetails } from "redux/actions/transactionActions";

const TransactionDownloadModal = ({
  isDownloadVisible,
  setIsDownloadVisible,
  downloadingTransaction,
}) => {
  return (
    <Modal
      showModal={isDownloadVisible}
      // customPadding={"0"}
      onClose={() => setIsDownloadVisible(false)}
    >
      <div className="mx-auto">
        <Typography
          variant="subtitle3"
          state="primary"
          className={"text-center mt-3"}
        >
          Download Report
        </Typography>
        <Typography
          state="grey"
          variant="caption1"
          className={"text-center mb-4"}
        >
          Choose how you will like to download your report
        </Typography>
      </div>
      <div className="footer d-flex justify-content-center align-items-center pb-4 download-modal-cta">
        {/* <Button
          label="Download as PDF"
          endIcon={<BiDownload fontSize="12px" />}
        />{" "} */}
        &nbsp; &nbsp;
        <Button
          label={downloadingTransaction ? "Downloading..." : "Download as CSV"}
          variant="secondary"
          endIcon={<BiDownload fontSize="12px" />}
          onClick={
            downloadingTransaction ? () => {} : downloadTransactionDetails
          }
        />
      </div>
    </Modal>
  );
};

export default TransactionDownloadModal;
